import stringToUint8Array from './stringToUint8Array';

/**
 * Converts a base 64 string into a `Uint8Array`.
 */

const base64ToUint8Array = (input: string): Uint8Array =>
    stringToUint8Array(window.atob(input));

export default base64ToUint8Array;